export default __webpack_public_path__ + "images/unclassified_instruction_2-7F4oG.png";